<rap-add-edit-producer-ui [title]="title" [errorMessage]="errorMessage$ | async" [userDetails]="userDetails$ | async"
    (addProducer)="addProducer($event)" (editProducer)="editProducer($event)"
    [isContributions]="isContributions"></rap-add-edit-producer-ui>